import { render } from "./index.vue?vue&type=template&id=5dec0e5c&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5dec0e5c&scoped=true&lang=sass"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dec0e5c"]])

export default __exports__